module.exports = __webpack_public_path__ + "media/images/redesign-images/rewards/loyalty-large-sorority-path-668ffd9244a5000265e2a771e9e1dd36.svg";